
import Swiper from '@/components/Base/Swiper/index.vue'
export default {
  components: {
    Swiper,
  },
  data() {
    return {
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesPerView: 1,
            gap: 0,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesPerView: 1,
            gap: 0,
          },
        },
        {
          breakpoint: 799,
          settings: {
            slidesPerView: 1,
            gap: 0,
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesPerView: 1,
            gap: 0,
          },
        },
      ],
      activeIndex: 0,
      intervl: -1,
      enterClass: 'fadeInLeft',
      leaveClass: 'fadeOutRight',
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    activeImage() {
      return this.item.items[this.activeIndex]
    },
  },
  methods: {
    next() {
      this.enterClass = 'fadeInLeft'
      this.leaveClass = 'fadeOutRight'
      let activeIndex = this.activeIndex + 1
      clearInterval(this.intervl)
      if (activeIndex > this.item.items.length - 1) {
        this.activeIndex = 0
      } else {
        this.activeIndex = activeIndex
      }
      this.start()
    },
    prev() {
      this.enterClass = 'fadeInRight'
      this.leaveClass = 'fadeOutLeft'
      clearInterval(this.intervl)
      let activeIndex = this.activeIndex - 1
      if (activeIndex < 0) {
        this.activeIndex = this.item.items.length - 1
      } else {
        this.activeIndex = activeIndex
      }
      this.start()
    },
    start() {
      this.intervl = setInterval(() => {
        this.next()
      }, 5000)
    },
  },
  beforeDestroy() {
    clearInterval(this.intervl)
  },
  mounted() {
    setTimeout(() => {
      this.start()
    }, 250)
  },
}
